<template>
  <div class="deluxe-layout" :class="[bodyClass, { dark: isDark, 'collapsed-sidebar': isSidebarCollapsed }]">
    <div class="wrapper">
      <div class="wrapper__inner">
        <DeluxeSidebar
          :collapsed="isSidebarCollapsed"
          :active-sidebar="activeSidebar"
          :dark="isDark"
          @toggle-collapse="toggleSidebar"
        />

        <main class="content" :class="bodyClass">
          <div class="content__top d-print-none">
            <div class="deluxe-topbar__inner">
              <DeluxeBreadcrumbs :body-class="bodyClass" />

              <div class="deluxe-topbar__actions">
                <button type="button" class="deluxe-icon-button deluxe-topbar__icon-doc" title="Document search">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M17.8018 13.1949V10.8755C17.8018 10.0846 17.4876 9.32606 16.9283 8.7668C16.3691 8.20755 15.6105 7.89336 14.8196 7.89336H13.4942C13.2306 7.89336 12.9778 7.78863 12.7913 7.60221C12.6049 7.41579 12.5002 7.16295 12.5002 6.89932V5.57393C12.5002 4.78302 12.186 4.0245 11.6267 3.46524C11.0675 2.90598 10.309 2.5918 9.51806 2.5918H7.86133M12.4834 14.5035L13.8256 15.8457M12.4834 14.5035C12.6988 14.2881 12.8698 14.0326 12.9863 13.7512C13.1029 13.4698 13.1629 13.1682 13.1629 12.8636C13.1629 12.2484 12.9185 11.6585 12.4835 11.2235C12.0486 10.7885 11.4586 10.5441 10.8435 10.5441C10.2283 10.5441 9.63835 10.7885 9.20337 11.2235C8.76839 11.6585 8.52402 12.2484 8.52402 12.8636C8.52402 13.1682 8.58402 13.4698 8.70058 13.7512C8.81714 14.0326 8.98799 14.2883 9.20337 14.5037C9.41875 14.719 9.67444 14.8899 9.95585 15.0065C10.2373 15.123 10.5389 15.183 10.8435 15.183C11.148 15.183 11.4497 15.123 11.7311 15.0065C12.0125 14.8899 12.268 14.7189 12.4834 14.5035ZM9.84941 2.5918H5.54189C4.99318 2.5918 4.54785 3.03713 4.54785 3.58584V18.1651C4.54785 18.7138 4.99318 19.1592 5.54189 19.1592H16.8077C17.3564 19.1592 17.8018 18.7138 17.8018 18.1651V10.5441C17.8018 8.43505 16.9639 6.41234 15.4726 4.92098C13.9812 3.42963 11.9585 2.5918 9.84941 2.5918Z" stroke="#777777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                </button>

                <div class="deluxe-language">
                <button type="button" class="deluxe-icon-button deluxe-topbar__icon-language" @click="isLanguageOpen = !isLanguageOpen">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M9.08105 17.5859L13.4561 8.21094L17.8311 17.5859M10.3311 15.0859H16.5811M2.83105 4.7701C4.48972 4.5637 6.1596 4.46045 7.83105 4.46094M7.83105 4.46094C8.76439 4.46094 9.69189 4.4926 10.6094 4.55594M7.83105 4.46094V2.58594M10.6094 4.55594C9.64439 8.9676 6.73939 12.6526 2.83105 14.6709M10.6094 4.55594C11.3561 4.60677 12.0969 4.67844 12.8311 4.7701M9.00689 11.8493C7.64019 10.4598 6.557 8.81759 5.81772 7.01427" stroke="#777777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
                <ul v-if="isLanguageOpen" class="lang">
                  <li><button type="button" @click="changeLocale('en')">English</button></li>
                  <li><button type="button" @click="changeLocale('zh-CN')">Chinese</button></li>
                </ul>
                </div>

                <button type="button" class="deluxe-icon-button deluxe-icon-button--accent deluxe-topbar__icon-bulb" @click="toggleDarkMode" :title="isDark ? 'Light mode' : 'Dark mode'">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <g clip-path="url(#clip0_deluxe_bulb)">
                    <path d="M11.0581 16.2418V11.603V16.2418ZM11.0581 11.603C11.5051 11.6033 11.9504 11.5472 12.3834 11.436L11.0581 11.603ZM11.0581 11.603C10.611 11.6033 10.1657 11.5472 9.73267 11.436L11.0581 11.603ZM13.0461 18.0435C11.7325 18.2929 10.3836 18.2929 9.06997 18.0435H13.0461ZM12.3834 20.1491C11.5023 20.2413 10.6139 20.2413 9.73267 20.1491H12.3834ZM13.0461 16.2418V16.0722C13.0461 15.2036 13.6275 14.4614 14.3786 14.0258C15.6404 13.2951 16.6259 12.1687 17.1826 10.821C17.7393 9.47339 17.8359 7.97979 17.4576 6.57164C17.0793 5.1635 16.2472 3.91942 15.0901 3.03218C13.9331 2.14494 12.5157 1.66406 11.0576 1.66406C9.59954 1.66406 8.18217 2.14494 7.02511 3.03218C5.86805 3.91942 5.0359 5.1635 4.6576 6.57164C4.2793 7.97979 4.37597 9.47339 4.93263 10.821C5.48928 12.1687 6.47486 13.2951 7.73663 14.0258C8.48769 14.4614 9.06997 15.2036 9.06997 16.0722V16.2418" fill="#FF671F" fill-opacity="0.6" />
                    <path d="M11.0581 16.2418V11.603M11.0581 11.603C11.5051 11.6033 11.9504 11.5472 12.3834 11.436M11.0581 11.603C10.611 11.6033 10.1657 11.5472 9.73267 11.436M13.0461 18.0435C11.7325 18.2929 10.3836 18.2929 9.06997 18.0435M12.3834 20.1491C11.5023 20.2413 10.6139 20.2413 9.73267 20.1491M13.0461 16.2418V16.0722C13.0461 15.2036 13.6275 14.4614 14.3786 14.0258C15.6404 13.2951 16.626 12.1687 17.1826 10.821C17.7393 9.47339 17.8359 7.97979 17.4576 6.57164C17.0793 5.1635 16.2472 3.91942 15.0901 3.03218C13.9331 2.14494 12.5157 1.66406 11.0576 1.66406C9.59954 1.66406 8.18217 2.14494 7.02511 3.03218C5.86805 3.91942 5.0359 5.1635 4.6576 6.57164C4.2793 7.97979 4.37597 9.47339 4.93263 10.821C5.48928 12.1687 6.47486 13.2951 7.73663 14.0258C8.48769 14.4614 9.06997 15.2036 9.06997 16.0722V16.2418" stroke="#FF671F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_deluxe_bulb">
                      <rect width="21.2062" height="21.2062" fill="white" transform="translate(0.189453 0.603516)" />
                    </clipPath>
                  </defs>
                </svg>
                </button>

                <a class="deluxe-mmoser-logo" href="#" title="MMOSER ASSOCIATES">
                <svg width="227" height="39" viewBox="0 0 227 39" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="MMOSER ASSOCIATES">
                  <path d="M184.118 21.989C184.65 24.0284 185.803 24.915 187.931 24.915C189.615 24.915 190.591 23.851 190.591 22.255C190.591 18.664 183.364 20.0827 183.364 15.6936C183.364 13.743 184.739 12.2356 187.221 12.2356C189.216 12.147 191.034 13.477 191.477 15.4276L190.413 15.738C189.926 14.275 188.906 13.211 187.177 13.211C185.625 13.211 184.561 14.0976 184.561 15.6493C184.561 16.536 184.827 17.201 187.266 18.132C191.034 19.5507 191.788 20.4373 191.788 22.388C191.788 24.649 189.881 25.8904 187.709 25.8904C185.138 25.8904 183.675 24.782 182.965 22.3437L184.118 21.989ZM173.567 25.713V12.413H181.148V13.4326H174.764V18.3537H179.374V19.3733H174.764V24.782H181.502V25.713H173.567ZM162.35 12.413H171.483V13.4326H167.537V25.713H166.296V13.3883H162.35V12.413ZM152.242 25.713H153.528L154.902 21.3684H159.956L161.286 25.713H162.572L158.36 12.413H156.498L152.242 25.713ZM155.168 20.393L157.385 13.3883L159.601 20.393H155.168ZM148.163 12.413H149.405V25.713H148.163V12.413ZM143.641 16.3143C143.065 14.3636 142.001 13.211 140.405 13.211C137.745 13.211 136.592 15.7823 136.592 19.063C136.592 22.3437 137.745 24.915 140.538 24.915C142.666 24.915 143.464 23.4077 143.907 21.6787L145.06 21.9004C144.572 24.2944 143.331 25.9347 140.538 25.9347C137.302 25.9347 135.395 23.186 135.395 19.1073C135.395 15.0286 137.302 12.28 140.538 12.28C142.932 12.28 144.218 13.9646 144.794 16.137L143.641 16.3143ZM127.903 12.2356C124.578 12.2356 122.627 15.1616 122.627 19.063C122.627 22.9644 124.534 25.8904 127.903 25.8904C131.272 25.8904 133.179 23.0087 133.179 19.063C133.179 15.1173 131.228 12.2356 127.903 12.2356ZM127.903 24.915C125.465 24.915 123.869 22.8314 123.869 19.063C123.869 15.2946 125.465 13.211 127.903 13.211C130.341 13.211 131.937 15.2946 131.937 19.063C131.937 22.8314 130.341 24.915 127.903 24.915ZM112.741 21.989C113.273 24.0284 114.425 24.915 116.553 24.915C118.238 24.915 119.214 23.851 119.214 22.255C119.214 18.664 111.987 20.0827 111.987 15.6936C111.987 13.743 113.361 12.2356 115.844 12.2356C117.839 12.147 119.613 13.477 120.1 15.4276L119.036 15.738C118.549 14.275 117.529 13.211 115.8 13.211C114.248 13.211 113.184 14.0976 113.184 15.6493C113.184 16.536 113.45 17.201 115.888 18.132C119.657 19.5507 120.411 20.4373 120.411 22.388C120.411 24.649 118.504 25.8904 116.332 25.8904C113.76 25.8904 112.297 24.782 111.588 22.3437L112.741 21.989ZM102.056 21.989C102.588 24.0284 103.741 24.915 105.869 24.915C107.554 24.915 108.529 23.851 108.529 22.255C108.529 18.664 101.303 20.0827 101.303 15.6936C101.303 13.743 102.677 12.2356 105.16 12.2356C107.155 12.147 108.972 13.477 109.416 15.4276L108.352 15.738C107.864 14.275 106.844 13.211 105.115 13.211C103.564 13.211 102.5 14.0976 102.5 15.6493C102.5 16.536 102.766 17.201 105.204 18.132C108.972 19.5507 109.726 20.4373 109.726 22.388C109.726 24.649 107.82 25.8904 105.647 25.8904C103.076 25.8904 101.613 24.782 100.904 22.3437L102.056 21.989ZM89.111 25.713H90.3967L91.771 21.3684H96.825L98.1551 25.713H99.4407L95.229 12.413H93.367L89.111 25.713ZM92.0814 20.393L94.2537 13.3883L96.5147 20.393H92.0814ZM87.0716 25.713L85.0323 19.9497C86.3623 19.2403 87.0273 18.1763 87.0273 16.4473C87.116 15.2503 86.584 14.0533 85.653 13.2996C84.7663 12.7233 83.7466 12.413 82.727 12.5016H76.9193V25.713H80.4659V20.659H81.5743L83.2146 25.713H87.0716ZM80.4216 17.8217V15.339H81.8403C82.195 15.2946 82.5053 15.3833 82.86 15.5163C83.2146 15.738 83.4363 16.1813 83.392 16.5803C83.392 17.733 82.461 17.866 81.7073 17.866L80.4216 17.8217ZM74.7469 25.713H66.1905V12.4573H74.7469V15.5163H69.6042V17.467H73.7716V20.393H69.6042V22.521H74.7469V25.713ZM57.4125 21.191C57.5898 22.2107 58.4765 22.92 59.4961 22.8314C59.9395 22.8314 60.8262 22.7427 60.8262 22.0334C60.8262 21.2353 59.9395 21.058 59.4518 20.9693C57.3238 20.4817 54.7524 19.8167 54.7524 16.669C54.7524 15.3833 55.2845 14.1863 56.2155 13.344C57.1465 12.6346 58.3435 12.28 59.4961 12.3243C61.4468 12.3243 63.3975 13.2553 64.0625 15.5606L61.1808 16.5803C60.9592 15.738 60.2055 15.1616 59.3631 15.2503C58.9198 15.2503 58.2105 15.4276 58.2105 16.0927C58.2105 16.7577 59.0528 16.935 59.4961 17.0237C60.6045 17.201 61.7128 17.5557 62.7325 18.0877C63.8408 18.8413 64.5058 20.127 64.4172 21.457C64.4172 24.649 61.7128 25.9347 59.3631 25.9347C57.0135 25.9347 54.8411 24.782 54.2204 21.9004L57.4125 21.191ZM47.0827 12.28C43.3144 12.28 41.1864 15.1616 41.1864 19.1517C41.1864 22.92 43.3144 25.9347 47.0827 25.9347C50.8511 25.9347 52.9791 22.92 52.9791 19.1517C52.9791 15.1616 50.8511 12.28 47.0827 12.28ZM47.0827 15.2946C48.7674 15.2946 48.9447 17.866 48.9447 19.196C48.9447 20.526 48.8117 22.92 47.0827 22.92C45.3537 22.92 45.2651 20.4817 45.2651 19.196C45.2651 17.9103 45.3981 15.2946 47.0827 15.2946ZM39.9007 25.713H35.822L35.1127 16.2257L32.896 25.713H30.1473L27.8863 16.2257L27.3099 25.713H24.5169L25.4479 12.4573H30.2803L32.0536 19.5063L33.694 12.4573H38.7924L39.9007 25.713ZM8.42383 25.713L9.4435 12.413H11.5272L14.9852 23.718L18.4876 12.413H20.5712L21.8126 25.713H20.4382L19.4186 13.3883L15.6502 25.713H14.4532L10.6405 13.3883L9.7095 25.713H8.42383Z" fill="black" />
                  <path d="M218.21 18.265V10.1963H200.433V27.9741H218.21V19.9054" fill="#FF671F" />
                  <path d="M209.033 24.7381H210.674V20.9697H209.078H209.033V24.7381Z" fill="white" />
                  <path d="M218.21 18.2646H202.028V19.905H218.21" fill="white" />
                  <path d="M205.265 20.9697H203.669V24.7381H205.265V20.9697Z" fill="white" />
                  <path d="M206.373 20.9697V24.7381H208.013V20.9697H206.373Z" fill="white" />
                </svg>
                </a>
              </div>
            </div>
          </div>

          <div class="content__wrapper" :class="bodyClass">
            <div class="content__inner">
              <slot />
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import DeluxeBreadcrumbs from '@/components/deluxe/DeluxeBreadcrumbs.vue'
import DeluxeSidebar from '@/components/deluxe/DeluxeSidebar.vue'
import { LocaleNameVariable, NormalizeLocale } from '@/translations/i18n.js'
import { UpdateMyLanguage } from '@/actions/userActions.js'
import dayjs from 'dayjs'

const LocalStorageModeName = 'lens_ui_mode'
const LocalStorageSidebarName = 'lens_deluxe_sidebar_collapsed'

export default {
  name: 'DeluxeLayout',
  components: {
    DeluxeBreadcrumbs,
    DeluxeSidebar
  },
  props: {
    bodyClass: {
      type: String,
      default: ''
    },
    activeSidebar: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isDark: window.localStorage.getItem(LocalStorageModeName) === 'dark',
      isSidebarCollapsed: false,
      isLanguageOpen: false
    }
  },
  mounted() {
    this.syncBodyClasses()
    document.addEventListener('click', this.closeLanguageFromOutside)
  },
  beforeUnmount() {
    this.clearBodyClasses()
    document.removeEventListener('click', this.closeLanguageFromOutside)
  },
  watch: {
    bodyClass() {
      this.syncBodyClasses()
    },
    isDark() {
      this.syncBodyClasses()
    },
    isSidebarCollapsed() {
      this.syncBodyClasses()
    }
  },
  methods: {
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed
      window.localStorage.setItem(LocalStorageSidebarName, String(this.isSidebarCollapsed))
    },
    toggleDarkMode() {
      this.isDark = !this.isDark
      window.localStorage.setItem(LocalStorageModeName, this.isDark ? 'dark' : 'light')
    },
    async changeLocale(value) {
      const locale = NormalizeLocale(value)
      this.$i18n.locale = locale
      window.localStorage.setItem(LocaleNameVariable, locale)
      document.documentElement.lang = locale
      dayjs.locale(locale === 'zh-CN' ? 'zh-cn' : 'en')
      this.isLanguageOpen = false

      const result = await UpdateMyLanguage({ language: locale })
      if (result === 'OK') {
        window.location.reload()
      }
    },
    closeLanguageFromOutside(event) {
      if (!event.target.closest('.deluxe-language')) {
        this.isLanguageOpen = false
      }
    },
    syncBodyClasses() {
      this.clearBodyClasses()
      document.body.classList.add('deluxe-body')

      if (this.bodyClass) {
        document.body.classList.add(...this.bodyClass.split(' ').filter(Boolean))
      }
      if (this.isDark) {
        document.body.classList.add('dark')
      }
      if (this.isSidebarCollapsed) {
        document.body.classList.add('collapsed-sidebar')
      }
    },
    clearBodyClasses() {
      document.body.classList.remove(
        'deluxe-body',
        'dark',
        'collapsed-sidebar',
        'theme-boq',
        'theme-quotation',
        'theme-bidding',
        'theme-project-archive',
        'theme-procurement',
        'theme-purchase-order',
        'theme-progress-claim',
        'theme-client-invoice',
        'theme-contingency',
        'theme-change-request'
      )
    }
  }
}
</script>
